export enum IS32LocalbusUnitType {
  S05 = 'S05',
  S05P = 'S05P',
  KL = 'KL',
  OP = 'OP',
  PD0304 = 'PD0304',
  PD0404 = 'PD0404',
  MO0104 = 'MO0104',
  MA0104 = 'MA0104',
  TTA = 'TTA',
  S05L = 'S05L',
  UNKNOWN_LB = 'UNKNOWN_LB',
  UNKNOWN_CB = 'UNKNOWN_CB',
}
